import { render, staticRenderFns } from "./close-account-page.vue?vue&type=template&id=7098c3b0&scoped=true"
import script from "./close-account-page.vue?vue&type=script&lang=js"
export * from "./close-account-page.vue?vue&type=script&lang=js"
import style0 from "./close-account-page.vue?vue&type=style&index=0&id=7098c3b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7098c3b0",
  null
  
)

export default component.exports